export enum GUEST_TYPES {
  GUEST = 'Guest',
  PROSPECT = 'Prospect',
  VENDOR = 'Vendor',
  DELIVERY = 'Delivery',
  EMERGENCY = 'Emergency (911)',
  // Somebody who LIVES here, coming in or going out. Not one of the four above:
  // every question those flows ask — approval, ID, parking validation — is a
  // question about an outsider, and none of them has an answer for a resident.
  // See resident-entry.tsx. The string is kept in step with VISITOR_KINDS in
  // lobbero_be/src/iq/vocabulary.js; it is 'Resident Entry' rather than
  // 'Resident' because the latter is already a daily-log activity.
  RESIDENT_ENTRY = 'Resident Entry',
  // A short-stay guest of a unit listed on Lobbero Stays (plan S3). NEVER a
  // wizard pick: the desk signs one in from Expected today (the stay's lane),
  // and the ordinary create refuses the kind. Kept in step with VISITOR_KINDS
  // in lobbero_be/src/iq/vocabulary.js so Records, filters and charts name it.
  SHORT_STAY_GUEST = 'Short-Stay Guest',
}

export enum VISITOR_TYPES {
  GUEST = 'guest',
  PROSPECT = 'prospect',
  VENDOR = 'vendor',
  DELIVERY = 'delivery',
  EMERGENCY = 'emergency',
}
